export default __webpack_public_path__ + "static/media/5.cfed2b73.jpg";